import { Component, OnInit } from '@angular/core';
import {KeycloakService} from '../core/services/keycloak.service';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from "@angular/router";

@Component({
  selector: 'homas-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  showLoading: boolean = false;

  constructor(private router: Router) {
    router.events.subscribe((event: RouterEvent) => {
      if(event instanceof NavigationStart){
        // console.info("Navigation Start");
        this.showLoading = true;
      }
      if(event instanceof NavigationEnd){
        // console.info("Navigation End");
        this.showLoading = false;
      }

      if(event instanceof NavigationCancel){
        // console.info("Navigation Cancel");
        this.showLoading = false;
      }

      if(event instanceof NavigationError){
        // console.info("Navigation Error");
        this.showLoading = false;
      }

    });
  }

  isBook() {
    return KeycloakService.keycloak.hasRealmRole("ROLE_BOOK");
  }

  isRace() {
    return KeycloakService.keycloak.hasRealmRole("ROLE_RACE");
  }

  isAdmin() {
    return KeycloakService.keycloak.hasRealmRole("ROLE_ADMIN");
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts